/**
 * status types for group sessions' patients
 */
export const GROUP_SESSION_PATIENT_STATUS_TYPES = Object.freeze({
  attending: "attending",
  cancelled_group_session: "cancelled_group_session",
  cancelled_by_patient: "cancelled_by_patient",
} as const);

export type TGroupSessionPatientStatusTypesKey =
  keyof typeof GROUP_SESSION_PATIENT_STATUS_TYPES;
